<template>

    <div>
        <v-app>
            <v-toolbar flat color="white">
                <v-toolbar-title class="congatec-gray">Pool groups</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-text-field id="pool_group_search_bar"
                              v-model="search"
                              class="searchbar"
                              append-icon="search"
                              label="Search"
                              single-line
                              hide-details></v-text-field>

                <v-btn id="create_pool_group_button" class="text-none" v-if="createPoolGroup" color="success"
                       @click.stop="onCreatePoolGroup()"><span
                        class="text-xs-left">Create pool group</span>
                </v-btn>

                <ShowPoolGroupModal v-model="showPoolGroupModal" :editMode="editMode" :disabled="disabled"
                                    :poolGroup="poolGroup"/>

                <AssignPoolToPoolGroupModal v-model="showPoolGroupAssignmentModal" :editMode="editMode"
                                            :disabled="disabled" :poolGroup="poolGroup"
                                            :poolGroupAssignmentList="poolGroupAssignmentList"/>

                <ConfirmPoolGroupDeletionModal v-model="showDeletionModal" :poolGroup="poolGroup"/>

            </v-toolbar>

            <v-divider></v-divider>

            <v-toolbar flat color="white" v-if="error">
                <v-spacer></v-spacer>

                <v-alert :value="error" type="error" transition="scale-transition">
                    {{ errorMessage }}

                    <v-btn small flat icon color="white" @click="closeAlert">
                        <v-icon>fas fa-times</v-icon>
                    </v-btn>
                </v-alert>

            </v-toolbar>

            <v-card flat>
                <v-data-table :headers="headers" :items="poolGroups" hide-actions :expand="expand" item-key="name"
                              :search="search" class="datatable">
                    <template slot="items" slot-scope="props">
                        <tr @click="props.expanded = !props.expanded">
                            <td class="width-id text-xs-left">{{ props.item.poolGroupId}}</td>
                            <td class="text-xs-left width-name">{{ props.item.name }}</td>
                            <td class="text-xs-left width-description">{{
                                props.item.description}}
                            </td>
                            <td class="width-hex text-xs-left"></td>
                            <td class="width-hex text-xs-left"></td>
                            <td class="width-hex text-xs-left"></td>
                            <td class="text-xs width-options text-xs-left">
                                <v-btn :id="'edit_pool_group_button_' + props.index" color="green" dark small
                                       @click.native.stop="onEditPoolGroup(props.item)">
                                    <v-icon v-if="isUpdateEnabled(props.item)" class="mr-2">edit</v-icon>
                                    <v-icon v-else class="mr-2">far fa-eye</v-icon>
                                </v-btn>
                                <v-btn :id="'assign_pool_group_button_' + props.index" dark small
                                       @click.native.stop="onAssignPoolToPoolGroup(props.item)">
                                    <v-icon class="mr-2">fa-link</v-icon>
                                </v-btn>

                                <v-btn :id="'delete_pool_group_button_' + props.index" color="red" dark small
                                       @click.native.stop="onDeletePoolGroupItem(props.item)"
                                       v-if="isDeleteEnabled(props.item)">
                                    <v-icon>delete</v-icon>
                                </v-btn>

                            </td>
                        </tr>
                    </template>
                    <template slot="expand" slot-scope="props">
                        <v-data-table hide-actions hide-headers :items="props.item.pools" :headers="headers">
                            <template slot="items" slot-scope="props">
                                <tr>
                                    <td v-if="props.item.isActive" class="width-id text-xs-left"
                                        style="background-color: #DCDCDC; font-weight:bold">
                                        <v-icon color="green" small>fas fa-circle</v-icon>
                                    </td>
                                    <td v-else class="width-id text-xs-left"
                                        style="background-color: #DCDCDC; font-weight:bold">
                                        <v-icon color="red" small>fas fa-circle</v-icon>
                                    </td>
                                    <td class="text-xs-left width-name"
                                        style="background-color: #DCDCDC; font-weight:bold">{{ props.item.name }}
                                    </td>
                                    <td class="text-xs-left width-description"
                                        style="background-color: #DCDCDC; font-weight:bold">{{
                                        props.item.description}}
                                    </td>
                                    <td class="text-xs-left width-hex"
                                        style="background-color: #DCDCDC; font-weight:bold">{{ props.item.oui }}
                                    </td>
                                    <td class="text-xs-left width-hex"
                                        style="background-color: #DCDCDC; font-weight:bold">{{ props.item.startMac }}
                                    </td>
                                    <td class="text-xs-left width-hex"
                                        style="background-color: #DCDCDC; font-weight:bold">{{ props.item.endMac }}
                                    </td>
                                    <td class="text-xs-left width-options">
                                    </td>
                                </tr>
                            </template>
                            <template slot="no-data">
                                <tr>
                                    <td class="text-xs-left"
                                        style="background-color: #DCDCDC; font-weight:bold; width: 73%">
                                        No pool assigned to pool group {{ props.item.name }}
                                    </td>
                                    <td class="text-xs-left" style="font-weight:bold; width: 27%">
                                    </td>
                                </tr>

                            </template>
                        </v-data-table>
                    </template>
                </v-data-table>
            </v-card>
        </v-app>
    </div>

</template>


<script>

    import poolgroupinterface from "../../interfaces/poolgroupinterface";
    import ShowPoolGroupModal from "./modals/ShowPoolGroupModal";
    import ConfirmPoolGroupDeletionModal from "./modals/ConfirmPoolGroupDeletionModal";
    import AssignPoolToPoolGroupModal from "./modals/AssignPoolToPoolGroupModal";
    import {EventBus} from "../../eventbus";
    import errormessagemanager from "../../managers/errormessagemanager";
    import poolgroupmanager from "../../managers/poolgroupmanager";
    import userinterface from "../../interfaces/userinterface";

    export default {
        name: "PoolGroupList",

        components: {
            ShowPoolGroupModal,
            ConfirmPoolGroupDeletionModal,
            AssignPoolToPoolGroupModal
        },

        data: () => ({
            expand: false,

            search: '',

            headers: [
                {text: '#', value: 'id'},
                {text: 'Name', value: 'name'},
                {text: 'Description', value: 'description'},
                {text: 'OUI', value: 'oui'},
                {text: 'Start MAC', value: 'startMac'},
                {text: 'End MAC', value: 'endMac'},
                {text: 'Options', value: 'options'}
            ],

            poolGroup: {
                poolGroupId: null,
                name: null,
                description: null,
                isEditDisabled: false
            },

            emptyPoolGroup: {
                poolGroupId: null,
                name: null,
                description: null,
                isEditDisabled: false
            },

            poolGroups: [],

            rights: [],
            createPoolGroup: false,
            deletePoolGroup: false,
            updatePoolGroup: false,

            error: false,
            errorMessage: "",

            response: null,

            poolGroupRights: [],

            editMode: false,
            disabled: false,
            poolGroupAssignmentList: [],

            showPoolGroupModal: false,
            showDeletionModal: false,
            showPoolGroupAssignmentModal: false
        }),

        mounted() {
            EventBus.$on('poolGroupModalClosed', () => {
                this.initialize();
                this.poolGroup = Object.assign({}, this.emptyPoolGroup);
                this.editMode = false;
            });
            EventBus.$on('refreshPoolGroupList', () => {
                this.initialize();
            });
            EventBus.$on('poolGroupDeletionClosed', () => {
                this.initialize();
                this.poolGroup = Object.assign({}, this.emptyPoolGroup);
                this.showDeletionModal = false;
            });
            EventBus.$on('poolGroupDeletionConfirmed', () => {
                this.initialize();
                this.poolGroup = Object.assign({}, this.emptyPoolGroup);
                this.showDeletionModal = false;
            });
            EventBus.$on('poolGroupAssignmentModalClosed', () => {
                this.initialize();
                this.poolGroup = Object.assign({}, this.emptyPoolGroup);
                this.showPoolGroupAssignmentModal = false;
                this.poolGroupAssignmentList = [];
            });
        },

        computed: {},

        async created() {
            this.initialize();
            await this.initializeRights();
        },

        methods: {

            onCreatePoolGroup() {
                this.editMode = false;
                this.disabled = false;
                this.poolGroup = Object.assign({}, this.emptyMacPool);

                this.showPoolGroupModal = true;
            },

            async onEditPoolGroup(poolGroup) {
                let group = {
                    poolGroupId: poolGroup.poolGroupId,
                    name: poolGroup.name,
                    description: poolGroup.description,
                    isEditDisabled: poolGroup.isEditDisabled,
                    pools: poolGroup.pools

                };

                this.poolGroup = Object.assign({}, group);
                this.editMode = true;
                this.disabled = !this.isUpdateEnabled(poolGroup);

                this.showPoolGroupModal = true;
            },

            onDeletePoolGroupItem(poolGroup) {
                this.poolGroup = Object.assign({}, poolGroup);
                this.showDeletionModal = true;
            },

            async onAssignPoolToPoolGroup(poolGroup) {
                let group = {
                    poolGroupId: poolGroup.poolGroupId,
                    name: poolGroup.name,
                    description: poolGroup.description,
                    isEditDisabled: poolGroup.isEditDisabled,
                    pools: poolGroup.pools

                };

                await poolgroupmanager.getPoolGroupAssignments(poolGroup, assignments => {
                    this.poolGroupAssignmentList = assignments;
                });

                this.poolGroup = Object.assign({}, group);
                this.editMode = true;
                this.disabled = !this.isUpdateEnabled(poolGroup);

                this.showPoolGroupAssignmentModal = true;
            },

            async onDeletePoolGroup(poolGroup) {
                let response = null;

                await poolgroupinterface.deletePoolGroup(poolGroup, requestResponse => {
                    response = requestResponse;
                });

                if (response != null && !response.error) {
                    const index = this.poolGroups.indexOf(poolGroup);
                    this.poolGroups.splice(index, 1);
                } else {
                    errormessagemanager.getDeletionErrorMessage(response.status, message => {
                        this.errorMessage = message;
                    });
                    this.error = response.error;
                }
            },

            initialize() {
                poolgroupinterface.getPoolGroups(poolGroups => {
                    this.poolGroups = poolGroups;
                });
            },

            async initializeRights() {

                await userinterface.updateCurrentUserRights();

                let rights = JSON.parse(this.$cookies.get("userRights"));

                rights.forEach(right => {
                    if (right.right === "PoolGroupModify") {
                        this.createPoolGroup = true;
                    }
                });
            },

            isDeleteEnabled(poolGroup) {
                let deleteEnabled = false;

                if (poolGroup.isEditDisabled) {
                    deleteEnabled = false;
                    return deleteEnabled;
                }

                let rights = JSON.parse(this.$cookies.get("userRights"));

                rights.forEach(right => {
                    if (right.right === "PoolGroupDelete" && right.referenceId === poolGroup.poolGroupId) {
                        deleteEnabled = true;
                    }
                });

                return deleteEnabled;
            },

            isUpdateEnabled(poolGroup) {
                let updateEnabled = false;

                if (poolGroup.isEditDisabled) {
                    updateEnabled = false;
                    return updateEnabled;
                }

                let rights = JSON.parse(this.$cookies.get("userRights"));

                rights.forEach(right => {
                    if (right.right === "PoolGroupModify") {
                        updateEnabled = true;
                        return true;
                    }

                    if (right.right === "PoolGroupUpdate" && right.referenceId === poolGroup.poolGroupId) {
                        updateEnabled = true;
                    }
                });

                return updateEnabled;
            },

            closeAlert() {
                this.error = false;
                this.errorMessage = null;
            }
        }
    };
</script>

<style>
    .width-id {
        width: 5%;
    }

    .width-name {
        width: 15%;
    }

    .width-description {
        width: 15%;
    }

    .width-hex {
        width: 10%
    }

    .width-options {
        width: 20%;
    }
</style>


// WEBPACK FOOTER //
// src/components/poolgroups/PoolGroupList.vue